/*
 * opts (element, file, queryType, data, callBack, fullscreen)
 */
$(document).ready(function () {
    var $W = $(window),
        $footer = $('.footer-wrap'),
        $D = $(document),
        isiPad = navigator.userAgent.match(/iPad/i) != null;


    // Прокрутка страницы вверх
    $('.js-scroll-top').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 800);

        return false;
    });

    function touhStopClick() {

    }

    // Появление и залипание кнопки прокрутки
    function scrollTopButton () {
        if ($W.scrollTop() > 100) {
            $('.js-scroll-top').fadeIn(100);
        } else {
            $('.js-scroll-top').fadeOut(100);
        }

        if ($footer.length) { //  && $W.width() >= 480
            if ($W.scrollTop() > $footer.position().top - $W.height() + 30) {
                $('.js-scroll-top').addClass('abs');
            } else {
                $('.js-scroll-top').removeClass('abs');
            }
        }

        // console.log(window.scrollY);
    }

    var w = $W.width(),
        menuMobile = $('.menu-mobile-wr');

    $W.on('resize', function() {
        w = $W.width();
    });

    scrollTopButton();

    $W.scroll(function () {
        scrollTopButton();
        //mobileMenuController();
    });

    function mobileMenuController() {
        var wTop = window.scrollY,
            menuMobileTop = menuMobile.offset().top,
            menuMoblieHeigt = menuMobile.height(),
            trigger = menuMobileTop;

        menuMobile.toggleClass('_fixed', wTop >= trigger)

        // if(wTop >== trigger) {
        //     menuMobile
        // }

        console.log(wTop, trigger);

    }

    // function initOpenTextBlock () {
    //     var $target = $('.js-textblock-inner'),
    //         baseHeight = '';
    //     if($('.js-textblock-inner').length) {
    //         baseHeight = $('.js-textblock-inner')[0].clientHeight;
    //     }

    //     // Открытие блока с текстом
    //     $('.js-textblock-link').click(function () {
    //         var $link = $(this),
    //             $textInner = $link.closest('.text-block').find('.js-textblock-inner'),
    //             $seoContainer = $('.js-textblock-inner').children(),
    //             seoHeight = $seoContainer[0].clientHeight;

    //         if (!$link.hasClass('active')) {

    //             if($seoContainer.hasClass('col')) {
    //                 $textInner.css({'max-height':seoHeight});
    //                 console.log($seoContainer, baseHeight, seoHeight);
    //             }
    //             $('.js-textblock-inner').addClass('open');
    //             $link.text('свернуть').addClass('active');
    //         } else {

    //             if($seoContainer.hasClass('col')) {
    //                 $textInner.css({'max-height':baseHeight});
    //                 console.log($seoContainer, baseHeight, seoHeight);
    //             }

    //             $('.js-textblock-inner').removeClass('open');
    //             $link.text('Читать далее').removeClass('active');
    //         }

    //         return false;
    //     });
    // }

    initOpenTextBlock();

// Фильтр

    // Включение фильтров в каталоге
    $('.js-open-filter').on('click', function () {
        $('.js-catalog-top-filter').addClass('catalog-filter-block--filter');
        $('.js-catalog-container').addClass('catalog-container--filter');
        return false;
    });

    $('.js-close-filter').on('click', function () {
        $('.js-catalog-top-filter').removeClass('catalog-filter-block--filter');
        $('.js-catalog-container').removeClass('catalog-container--filter');
        return false;
    });


    // Размеры
    $('.js-clear-sizes').on('click', function () {
        $D.find('.js-opsize').find('.all').find('a').click();
        $(this).hide();
    });

    $('.js-opsize a').on('click', function () {
        if ($(this).closest('li').hasClass('all')) {
            $('.js-clear-sizes').hide();
        } else {
            $('.js-clear-sizes').show();
        }
    });


// Баннер вверху страницы

    $('.js-top-bnr-close').click(function () {
        $('.js-top-bnr').hide();

        setCookie({'topBanner': 1}, 172800);

        return false;
    });

    if (getCookie('topBanner') == 1) {
        $('.js-top-bnr').hide();
    }

    //фиксированное меню
    $(".menu-wrap").sticky({topSpacing:44});

    if (isiPad) {
        $('.catalog-links-look-wrap').find('.catalog-link-look-category').css('opacity', 1);
    }

    //tabs
    addToCartTabs($('.jt-wrapper'));

    //cart popup form validation
    $('#cart-popup-reg-form').formValidation();

    //discount form
    if ($('#discount-form').length) {
        $('#discount-form').discountCheck();
    }

    //tags toggle
    $('.tag-links-block__toggle').on('click', function (event) {
        tagsToggle(event, $(this))
    });

    //delivery radio buttons
    //$('.js-order-step-shipping').each(function () {
    //    var wrap = $(this),
    //        lvl1 = $('.js-delivery-input', wrap),
    //        lvl2 = $('.js-delivery-places-input', wrap);
    //
    //    lvl1.on('click', function () {
    //        lvl2.filter(':checked').prop('checked', false);
    //        $(this).parent().find('.js-delivery-places-input').eq(0).prop('checked', true);
    //    }).filter(':checked').click();
    //});

    setTimeout(function() {
        if ($('.progres b').length && (
            $('.progres b').text() === 'Способ доставки'
            || $('.progres b').text() === 'Способ оплаты'
            || $('.progres b').text() === 'Подтверждение заказа'
        )) {
            onbeforeunload = function() {
                $.ajax({
                    type: "GET",
                    url: '/account/forgottenCart/create',
                    async: false,
                    success : function(data) {
                        alert('done');
                    }
                });
            }
        }
    }, 1000);

    //popup hash
    openModWinHash();
}); // document.ready

(function() {

    window.initOpenTextBlock = function() {

        var $target = $('.js-textblock-inner'),
            baseHeight = '';
        if($('.js-textblock-inner').length) {
            baseHeight = $('.js-textblock-inner')[0].clientHeight;
        }

        // Открытие блока с текстом
        $('.js-textblock-link').click(function () {
            var $link = $(this),
                $textInner = $link.closest('.text-block').find('.js-textblock-inner'),
                $seoContainer = $('.js-textblock-inner').children(),
                seoHeight = $seoContainer[0].clientHeight;

            if (!$link.hasClass('active')) {

                if($seoContainer.hasClass('col')) {
                    $textInner.css({'max-height':seoHeight});
                    // console.log($seoContainer, baseHeight, seoHeight);
                }
                $('.js-textblock-inner').addClass('open');
                $link.text('свернуть').addClass('active');
            } else {

                if($seoContainer.hasClass('col')) {
                    $textInner.css({'max-height':baseHeight});
                    // console.log($seoContainer, baseHeight, seoHeight);
                }

                $('.js-textblock-inner').removeClass('open');
                $link.text('Читать далее').removeClass('active');
            }

            return false;
        });
    }
})();

function addPhonePlaceholder(elem) {
    if (!$(elem).length) return;

    $(elem).on({
        keydown: function() {
            $(this).parent().find('span.phone-placeholder-mask b').css('opacity', 0);
        },
        blur: function() {
            if ($(this).val() == ''){
                $(this).parent().find('span.phone-placeholder-mask b').css('opacity', 1);
            }
        }
    });
    $(elem).blur();
}

function tagsToggle (event, elem) {
    var height = elem.parent().find('.tag-links-block__blured').data('height');
    event.preventDefault();

    elem.closest('.tag-links-block').toggleClass('tag-links-block-open');

    if (elem.closest('.tag-links-block').hasClass('tag-links-block-open')) {
        elem.parent().find('.tag-links-block__blured').css('max-height', '400px');
    } else {
        elem.parent().find('.tag-links-block__blured').css('max-height', height);
    }
}

(function ( $ ) {

    $.fn.discountCheck = function () {

        this.on('submit', function (event) {

            event.preventDefault();

            var form = $(this),
                cartnum,
                codeField = $('#discount');

            if ( codeField.val() == '' || !isNumeric( codeField.val() ) ) {
                addAnim(codeField, 'shake');
                return;
            }

            checkCardNum();

            function checkCardNum() {
                $.ajax({
                    type: 'POST',
                    url: form.attr('action'),
                    data: codeField.serialize(),
                    dataType: 'json',
                    success: function(msg) {

                        if (msg['state'] === 1) {

                            saveCardNum();//сохраняем номер карты для последующих шагов

                            if (msg['birthday-date']) {//если дата есть в базе
                                showStep('.discount-step-5');//переходим на следующий шаг
                                setDate(msg['birthday-date'], '.discount-step-5');//ставим указанную дату рождения
                                sendBirthdayDate();//вешаем обработчик для подтверждения даты
                            } else {//если даты нет в базе
                                showStep('.discount-step-4');//переходим на следующий шаг
                                sendBirthdayDate();//вешаем обработчик для добавления даты
                            }
                        } else if(msg['state'] === 2) {
                            showStep('.discount-step-6'); // День рождения уже подтверждён
                            addAnim($('.discount-step-6 img'), 'flip');
                        } else {
                            showStep('.discount-step-3');//показываем ошибку
                            addAnim($('.discount-step-3 img'), 'pulse');
                        }
                    }
                });

                return false;
            }

            $('.discount-error-msg-close').on('click', function () {
                showStep('.discount-step-1');
                $('#discount').val('');

                return false;
            });

            function setDate(date, container) {
                var birthDate = new Date(date),
                    dd = birthDate.getDate(),
                    mm = birthDate.getMonth()+1,
                    yy = birthDate.getFullYear();

                $(container).find('select[name="discount-confirm-date"]').val(dd);
                $(container).find('select[name="discount-confirm-month"]').val(mm);
                $(container).find('select[name="discount-confirm-year"]').val(yy);
            }

            function sendBirthdayDate() {
                form.find('.discount-send-bd').click(function (event) {
                    var container = $(this).parents('div[class*="discount-step"]'),
                        inputs = container.find(':input');

                    event.preventDefault();

                    validate();

                    if (!container.find('.validate-er').length) {
                        sendDate();
                    }

                    function sendDate() {
                        $.ajax({
                            type: 'POST',
                            url: form.attr('action'),
                            data: inputs.serialize()+'&discount='+$('#discount').val(),
                            success: function() {
                                showStep('.discount-step-2');
                                addAnim($('.discount-step-2 img'), 'flip');
                            }
                        });
                    }

                    function validate() {
                        container.find('select').removeClass('validate-er');

                        container.find('select').each(function (i, el) {
                            if ($(el).val() == '') {
                                addAnim(container.find('.discount-birthday'), 'shake');
                                $(el).addClass('validate-er');
                            }
                        });
                    }
                });
            }

            function saveCardNum() {
                var num = $('#discount').val();
                form.find('input[name="discount"]').val(num);
            }

            function showStep(step) {
                form.find('div[class*="discount-step"]:visible').hide();
                form.find(step).fadeIn('fast');
            }
            function addAnim(elem, anim) {
                elem.addClass(anim + ' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    $(this).removeClass('shake animated');
                });
            }
            function isNumeric(n) {
                return !isNaN(parseFloat(n)) && isFinite(n) && n.indexOf(".") < 0;
            }
        });
    }
})( jQuery );

(function ( $ ) {

    $.fn.formValidation = function () {

        this.on('submit', function (event) {

            event.preventDefault();

            var form = $(this),
                textField = form.find('input[type="text"]'),
                textFieldTel = form.find('input[name="phone"]'),
                submit = form.find('input[type="submit"]'),
                submitVal = submit.val();

            form.find('.require').each(function (i, el) {

                var input = $(el);

                checkValidate(input);

                $(input).bind('keydown', function () {
                    checkValidate(input);
                });
            });

            if ( form.find('.validate-error').length ) {
                return false;
            }

            form.find('[type="submit"]').attr('disabled', true);

            $.post(form.attr('action'), form.serialize(),
                function (data) {
                    submit.prop('disabled', false);
                    textField.val('');

                    console.log(data);

                    if (data.error) {
                        showErrMsg(data.error);

                        $('.cart-popup-error-message').on('click', function () {
                            hideErrMsg();
                            return false;
                        });
                    }
                    else {
                        showThsMsg();

                        $('.cart-popup-thanks-message').on('click', function () {
                            hideThsMsg();
                            return false;
                        });
                    }

                    form.find('[type="submit"]').removeAttr('disabled');
                }
            ).fail(
                function (jqXHR, textStatus, errorThrown) {
                    submit.prop('disabled', false);
                    textField.val('');

                    showErrMsg(jqXHR.responseText);

                    $('.cart-popup-error-message').on('click', function () {
                        hideThsMsg();
                        $('.cart-popup-thanks-message').removeClass('error');
                        return false;
                    });
                }
            );
            function showThsMsg() {
                $('.cart-popup-thanks-message').show();
                $('.cart-popup-inner').hide();
            }
            function showErrMsg(msg) {
                var error_message_popup = $('.cart-popup-error-message');
                error_message_popup.find('.message').html(msg);
                error_message_popup.show();
                $('.cart-popup-inner').hide();
            }
            function hideThsMsg() {
                $('.cart-popup-thanks-message').hide();
                $('.cart-popup-inner').show();
            }
            function hideErrMsg() {
                $('.cart-popup-error-message').hide();
                $('.cart-popup-inner').show();
            }
            function checkValidate(input) {
                var emailRegExp = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;

                if ( input.val() == '' ) { //проверка на пустоту поля
                    input.addClass('validate-error');
                } else if ( input.attr('name') == 'phone' && isNaN( input.val() ) ) { //проверка на корректность поля тедефон
                    input.addClass('validate-error');
                } else if ( input.attr('name') == 'email' && !emailRegExp.test(input.val()) ) { //проверка валидности email`а
                    input.addClass('validate-error');
                }else {
                    if ( input.is('.validate-error') ) {
                        input.removeClass('validate-error');
                    }
                }
            }
        });
    }
})( jQuery );

//product share
var Share;

$(document).ready(function () {
    Share = {
        options: (function () {
            var url = location.href,
                title = $('h1').text() + ' Thomas Münz ' + $('.prod-block link').attr('content'),
                twTitle = $('h1').text() + ' Thomas Münz',
                desc = document.title.replace('Munz', 'Münz').replace('MUNZ', 'MÜNZ'),
                img = $('#productMainPic').attr('src');

            return {
                url: url ,
                title: title,
                twTitle: twTitle,
                desc: desc,
                img: img
            }
        })(),
        vkontakte: function() {
            url  = 'http://vkontakte.ru/share.php?';
            url += 'url='          + encodeURIComponent(this.options.url);
            url += '&title='       + encodeURIComponent(this.options.title);
            url += '&description=' + encodeURIComponent(this.options.desc);
            url += '&image='       + encodeURIComponent(this.options.img);
            url += '&noparse=true';
            Share.popup(url);
            console.log(this.options.img);
        },
        facebook: function() {
            url  = 'http://www.facebook.com/sharer.php?s=100';
            url += '&p[title]='     + encodeURIComponent(this.options.title);
            url += '&p[summary]='   + encodeURIComponent(this.options.desc);
            url += '&p[url]='       + encodeURIComponent(this.options.url);
            url += '&p[images][0]=' + encodeURIComponent(this.options.img);
            Share.popup(url);
        },
        twitter: function() {
            url  = 'http://twitter.com/share?';
            url += 'text='      + encodeURIComponent(this.options.twTitle);
            url += '&url='      + encodeURIComponent(this.options.url);
            url += '&counturl=' + encodeURIComponent(this.options.url);
            Share.popup(url);
        },
        mailru: function() {
            url  = 'http://connect.mail.ru/share?';
            url += 'url='          + encodeURIComponent(this.options.url);
            url += '&title='       + encodeURIComponent(this.options.title);
            url += '&description=' + encodeURIComponent(this.options.desc);
            url += '&imageurl='    + encodeURIComponent(this.options.img);
            Share.popup(url)
        },
        gg: function () {
            url  = 'https://plus.google.com/share?';
            url += 'url='          + encodeURIComponent(this.options.url);
        },
        popup: function(url) {
            window.open(url,'','toolbar=0,status=0,width=626,height=436');
        }
    };
});

function addToCartTabs (elem) {
    var tabsNav = elem.children('.just-tabs'),
        tabsNavLink = tabsNav.find('.link_tabs');

    tabsNavLink.bind('click', function (event) {

        if ( !$(event.target).is('.link_tabs_active') ) {
            var tabID = $(event.target).attr('data-tab');

            selecttab(tabID);
        }
        return false;
    });

    function selecttab(index) {
        var tabsNav = elem.children('.just-tabs'),
            tabsWrap = elem.children('.content_tabs');

        tabsNav.find('.link_tabs').removeClass('link_tabs_active');
        tabsWrap.children('.content__tab').hide();
        tabsNav.find('[data-tab="' + index + '"]').addClass('link_tabs_active');
        tabsWrap.children('.' + 'tab-' + index).show();
    }
}

function setMenuIpad() {

    $('#lang, .menu.mmenu li a').each(function () { // have to use an `each` here - either a jQuery `each` or a `for(...)` loop

        var onClick; // this will be a function
        var firstClick = function () {
            onClick = secondClick;
            return false;
        };
        var secondClick = function () {
            onClick = firstClick;
            return true;
        };
        onClick = firstClick;
        $(this).click(function () {
            if (cElementMenu !== this) {
                onClick = firstClick;
                cElementMenu = this;
            }
            return onClick();
        });
    });
}


function openModWin(opts) {

    if (opts.element !== undefined) {
        toggleError();

        if (opts.file === undefined) {
            var el = $('#' + opts.element);
            if (el.attr('id') === undefined) {
                if (typeof(console) === 'object')
                    console.log('modwin element does not exists');
                return false;
            } else {
                var $slider = $('#dmw').find('#otherPicsContainer');
                var $availablePopupSlider = $('body').find('.ap-goods-available-salons');

                if($slider.length) initSlider($slider);

                if($availablePopupSlider.length && !$availablePopupSlider.hasClass('slick-slider') && window.innerWidth < 768)
                    initAvailablePopupSlider($availablePopupSlider);

                $('#dmw').show();

                var cs = getContentSize(), ps = getPageSize();
                $('#dmwbg').css('height', cs.height)
                .css('width', (cs.width - ps.width <= (screen.availWidth - ps.width)) ? cs.width - screen.availWidth + ps.width : cs.width)
                .bind('click', function() {
                    closeModWin(opts.element);
                });
                el.show();
                centralAlign(el, opts.fullscreen);
                if (typeof(opts.callBack) === 'function')
                    opts.callBack();
            }
        }
        else {
            $.ajax({
                "type": (opts.queryType === undefined) ? "GET" : opts.queryType,
                "url": opts.file,
                "data": opts.data,
                "success": function(msg) {
                    $('#' + opts.element).remove();
                    $('#dmw').append(msg);
                    delete opts.file;
                    openModWin(opts);

                    if (typeof $.bindFormValidate == 'function' && $.bindFormValidate()) {
                        $.bindFormValidate();
                    }
                },
                "error": function(obj, status, error) {
                    ajaxError(obj, status, error);
                }
            });
        }
    } else {
        return false;
    }
    return true;
}

function ajaxError(obj, status, error) {
    if (obj.status == 401) {
        notifyUnauthorized();
    } else if (obj.status == 403) {
        notifyForbidden();
    } else if (obj.status == 404) {
        toggleError("Запрашиваемая страница не существует или недоступна");
    }
    if (typeof(console) === 'object')
        console.log('AJAX failed with status: "' + status + '(' + obj.status + ')", http: "' + error + '"');
}

function notifyForbidden() {
    toggleError("Доступ запрещен");
}

function notifyUnauthorized() {
    toggleError("Вы не авторизованы");
}

function closeModWin(element) {
    $('body').attr('style', '');
    if (element === undefined) {
        $('#dmw').children('.modwin').last(':visible').hide();
        $('#dmw').find('img').attr('src','');
        $('.modal-win').hide();
    } else {
        $('#' + element).hide();
    }
    $('#dmwbg').unbind('click').css('height', 0).css('width', 0);
    $('#dmw').hide();
}

function openModWinHash() {
    var hash = ['available-popup'],
        i;

    for (i = 0;i < hash.length; i++) {
        if ( '#'+hash[i] == window.location.hash ) {
            openModWin({'element': hash[i]});
        }
    }
}

function centralAlign(el, fullscreen) {
    if (typeof(fullscreen) === 'undefined')
        fullscreen = false;
    if (el.attr('id') === undefined) {
        if (typeof(console) === 'object')
            console.log('central align on empty element');
        return false;
    }
    var page, scroll = getScrollValue();
    if ($.browser.msie)
        scroll.left -= 10;
    if (!fullscreen)
        page = getPageSize();

    var margin = el[0].clientWidth/2;

    var t = (fullscreen ? 0 : Math.round((page.height - el.height())/3)) + scroll.top;
    var l = (fullscreen ? 0 : Math.round((page.width - el.width())/2)) + scroll.left;
    t = (t > 0) ? t : 0;
    l = (l > 0) ? l : 0;
    el.css('top', t).css('left', '50%');
    el.css('margin-left', '-'+margin+'px');

    if (fullscreen)
        $("body").attr("style", "overflow: hidden;");

    //$('window, body').off('resize.popup');
    //$('window, body').on('resize.popup', centralAlign.bind(window, el, fullscreen));

    return true;
}

function getContentSize() {
    var w1 = ((typeof(window.scrollMaxY) === 'undefined') || (document.body.scrollWidth > window.scrollMaxY)) ? document.body.scrollWidth : window.scrollMaxY;
    var w2 = (document.body.scrollWidth > screen.availWidth) ? document.body.scrollWidth : screen.availWidth
    //var ps = getPageSize();
    //var w3 = ps.width + ((typeof(window.pageYOffset) === 'undefined') ? document.body.scrollLeft : window.pageYOffset);
    return {
        "width": Math.max(w1, w2),
        "height": (document.body.scrollHeight > screen.availHeight) ? document.body.scrollHeight : screen.availHeight
    };
}

function getPageSize() {
    var w = ((typeof(window.innerWidth) === 'undefined') || (screen.availWidth < window.innerWidth)) ? screen.availWidth : window.innerWidth;
    if ((typeof(document.documentElement.offsetWidth) !== 'undefined') && (document.documentElement.offsetWidth > 0))
        w = Math.min(w, document.documentElement.offsetWidth);
    var h = ((typeof(window.innerHeight) === 'undefined') || (screen.availHeight < window.innerHeight)) ? screen.availHeight : window.innerHeight;
    if ((typeof(document.documentElement.offsetHeight) !== 'undefined') && (document.documentElement.offsetHeight > 0))
        h = Math.min(h, document.documentElement.offsetHeight);
    if (h < screen.availHeight)
        h = screen.availHeight;
    return {
        "width": w,
        "height": h
    };
}

function getScrollValue() {
    return {
        "top": document.body.scrollTop ? document.body.scrollTop : document.documentElement.scrollTop,
        "left": document.body.scrollLeft ? document.body.scrollLeft : document.documentElement.scrollLeft
    };
}

function toggleError(msg, element){
    if (element === undefined)
        element = 'feedbackContainer';
    var el = $('#' + element).removeClass('fbok').addClass('fber');
    if (msg === undefined){
        if (el.attr('id') !== undefined)
            el.hide();
        return;
    }
    var html = '';
    if (typeof(msg) == 'object'){
        for (var k in msg){
            html += (el.attr('id') === undefined) ?  msg[k] + "\n" : "<p>" + msg[k] + "</p>";
        }
    } else {
        html += (el.attr('id') === undefined) ?  msg + "\n" : "<p>" + msg + "</p>";
    }
    if (el.attr('id') === undefined)
        alert(html);
    else {
        el.html(html).show();
        var sv = getScrollValue();
        if (el.offset().top < sv.top) {
            el.get(0).scrollIntoView();
        }
    }
}

function toggleSuccess(msg, loc, timeout, element){
    if (element === undefined)
        element = 'feedbackContainer';
    var el = $('#' + element).removeClass('fber').addClass('fbok');
    if (msg === undefined){
        if (el.attr('id') !== undefined)
            el.fadeOut(800);
        return;
    }
    var html = '';
    if (typeof(msg) == 'object'){
        for (var k in msg){
            html += (el.attr('id') === undefined) ?  msg[k] + "\n" : "<p>" + msg[k] + "</p>";
        }
    } else {
        html += (el.attr('id') === undefined) ?  msg + "\n" : "<p>" + msg + "</p>";
    }
    if (el.attr('id') === undefined)
        alert(html);
    else {
        el.html(html).show();
        var sv = getScrollValue();
        if (el.offset().top < sv.top) {
            el.get(0).scrollIntoView();
        }
    }
    if(loc !== undefined)
        setTimeout('location.href="'+loc+'"', (timeout - 1 > 0) ? timeout - 1 : 2000);
    setTimeout(function(){
        toggleSuccess(undefined, undefined, undefined, element);
    }, (timeout > 0) ? timeout : 2000);
}

function getLocation(path, params, exclude){
    if (path === undefined)
        path = '';
    var loc = location.pathname + path;
    if (typeof(params) == 'object'){
        var get = parseGET();
        for (var k in params)
            get[k] = params[k];
        if (typeof(exclude) == 'object'){
            for (var k in exclude)
                delete get[exclude[k]];
        }
        if (get.length != 0){
            loc += '?';
            for (var k in get)
                loc += k+'='+get[k]+'&';
            loc = loc.substr(0, loc.length - 1);
        }
    } else {
        if (location.search != '')
            loc += location.search;
    }
    return loc;
}

function parseGET(){
    var tmp = new Array();
    var get = {};

    var url = location.search;
    if(url != '') {
        url = (url.substr(1)).split('&');
        for(var k in url) {
            tmp = url[k].split('=');
            get[tmp[0]] = tmp[1];
        }
    }
    return get;
}

function openWindow(link, w, h) {
    var win = "width=" + w + ",height=" + h
    + ",menubar=no,location=no,resizable=yes,scrollbars=yes";
    var newWin = window.open(link, 'newWin', win);
    if (newWin)
        newWin.focus();
    return newWin;
}

function getCookie(name) {
    var value = document.cookie;
    var start = value.indexOf(" " + name + "=");
    if (start === -1)
        start = value.indexOf(name + "=");
    if (start === -1) {
        value = undefined;
    } else {
        start = value.indexOf("=", start) + 1;
        var end = value.indexOf(";", start);
        if (end === -1)
            end = value.length;
        value = unescape(value.substring(start, end));
    }
    return value;
}

function setCookie(vs, exp, path) {
    if (path === undefined)
        path = '/';
    for (var k in vs) {
        document.cookie = k + '=' + vs[k] + ';expires=' + (new Date((new Date()).getTime() + exp * 1000)).toGMTString() + ';path=' + path + ';';
    }
}

function feedback_field() {
    if($("#feedback option:selected").attr("add_field") == 1) {
        $("#dmestheme_01").fadeOut('slow',function() {
            $("#dmestheme_02").fadeIn('slow');
        });
    }
    else if($("#feedback option:selected").attr("order") == 1) {
        $("#dmestheme_02").fadeOut('slow',function() {
            $("#dmestheme_01").fadeIn('slow');
        });
    }
    else {
        $("#dmestheme_01").fadeOut('slow');
        $("#dmestheme_02").fadeOut('slow');
    }
}

function defaultKeyDown(e) {
    if (e.keyCode == 27)
        closeModWin();
}

//half price banner btn
function halfPriceEvent() {
//    var detail = $('.half-price--btn-detail'),
//        hidden = $('.half-price--text'),
//        close = $('.half-price--text-close');

    $('.half-price--btn-detail').on('click', function () {
        $('.half-price--text')
            .toggleClass('banner-open')
            .stop(false, true)
            .fadeToggle(500);

        if ($('.half-price--text').hasClass('banner-open')) {
            scrollToText();
        }

        return false;
    });

    $('.half-price--text-close').on('click', function () {
        $('.half-price--text')
            .removeClass('banner-open')
            .stop(false, true)
            .fadeOut(500);

        return false;
    });

    function scrollToText() {
        var top = $('.half-price--banner').offset().top-94;

        $('html, body').animate({
            scrollTop: top
        }, 400);
    }
}

$(function() {
    $("html").bind("keydown", function(e) {
        defaultKeyDown(e);
    });

    //half price banner
    halfPriceEvent();
});

var tm = tm || {};

tm.$W = $(window);
tm.$D = $(document);

function library(module) {
    $(function() {
        if (module.init) {
            module.init();
        }
    });
    return module;
}

tm.AvailablePopupReserve = library(function() {
    return {
        init: function () {
            this.elements = {
                popup: $('.available-popup')
            };

            if(!this.elements.popup) return;

            this.bind();
        },
        bind: function () {
            var obj = this;

            obj.elements.popup.find('.js-ap-form').on('submit', function (event) {
                var
                    $this = $(this),
                    input = $this.find('input');

                event.preventDefault();

                $this.find('.require').each(function (i, el) {
                    var input = $(el);

                    obj._validate(input);
                });

                if (!input.hasClass('validate-error')) {
                    obj._send($this);
                }
            });

            obj.elements.popup.find('.js-ap-reserve').on('click', function (event) {
                var self = $(this),
                    prod_id = $('#available-popup .ap-goods-info').data('id'),
                    salon = self.parents('.ap-goods-available-salon__item'),
                    salon_id = salon.data('id'),
                    salonSizes = salon.find('.salon-item__sizes .salons-size__item'),
                    reserveBlock = obj.elements.popup.find('.ap-reservation'),
                    reserveBlockSizes = reserveBlock.find('.ap-reservation__sizes');

                event.preventDefault();

                if (salon.find('.js-map-inner').length) {
                    salon.find('.js-map-inner').remove();
                    salon.find('.js-ap-map-close').hide();
                    salon.find('.js-salons-buttons__map').show();
                }

                reserveBlock.find('.ap-reservation__item').html(salon.clone());

                // Copy sizes.
                if (salonSizes) {
                    var newSizesHtml = '';
                    var sizesList = reserveBlockSizes.find('.ap-reservation-sizes__list');

                    salonSizes.each(function(i){
                        var $this = $(this);
                        var prop_id = $this.data('prop-id');
                        var size = $this.text();

                        newSizesHtml += '<li>';
                        newSizesHtml += '<input type="checkbox" name="ap-size" value="' + prop_id + '" id="ap-size-' + i + '">';  //заменил пока prop_id на i (prop_id должен быть один?)
                        newSizesHtml += '<label for="ap-size-' + i + '">' + size + '</label>';
                        newSizesHtml += '</li>';
                    });

                    sizesList.html(newSizesHtml);
                }
                else {
                    reserveBlockSizes.hide();
                }

                // Set item properties.
                reserveBlock.find('[name="warehouseID"]').val(salon_id);
                reserveBlock.find('[name="prod_id"]').val(prod_id);

                reserveBlock.show();
            });

            obj.elements.popup.find('.js-reservation-close').on('click', function () {
                var reserveBlock = $(this).parent();
                reserveBlock.hide();
            });

            // Reserve form sizes.
            obj.elements.popup.find('.ap-reservation-sizes__list [type="checkbox"]').on('change', function (event) {
                console.log('CHANGED');
                var $this = $(this);
                var val = $this.val();
                var checked = $this.prop('checked');

                // Uncheck all.
                $this.closest('ul').find(':checked').each(function() {
                    $(this).prop('checked', false);
                });

                if (checked) {
                    $('.ap-reservation__sizes .bbaskfb').hide();
                    $this.prop('checked', true);
                    $this.closest('form').find('[name="prop_id"]').val(val);
                }
            });

            // Hide phone mask
            obj.elements.popup.find('.ap-reservation__text-field.js-ap-phone').on('input', function (event) {
                var $this = $(this);
                var mask = obj.elements.popup.find('.phone-placeholder-mask');


                if ($this.val()) {
                    mask.hide();
                }
                else {
                    mask.show();
                }
            });
        },
        _validate: function (elem) {
            var obj = this;

            checkValidate(elem);

            function checkValidate(input) {
                var form = input.parents('form'),
                    emailRegExp = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;

                if ( input.val() == '' || ( $(input).attr('type') === 'checkbox' && $(input).is(':checked') === false ) ){ //проверка на пустоту поля
                    input.addClass('validate-error');
                } else if ( input.attr('name') == 'email' && !emailRegExp.test(input.val()) ) { //проверка валидности email`а
                    input.addClass('validate-error');
                }else {
                    if ( input.is('.validate-error') ) {
                        input.removeClass('validate-error');
                    }
                }
            }
        },
        _send: function (form) {
            var formWrap = form.parent(),
                sizes_wrapper = form.find('.ap-reservation__sizes:visible'),
                message = formWrap.find('.success-reserve'),
                submitButton = form.find('[type="submit"]');

            submitButton.attr('disabled', true);

            var validation_error = false;

            if (sizes_wrapper.length && !sizes_wrapper.find(':checked').length) {
                sizes_wrapper.find('.bbaskfb').show();
                validation_error = true;
            }

            if (validation_error) {
                submitButton.removeAttr('disabled');
                return;
            }

            var data = form.serialize();

            // Add +7 to the phone number.
            data = data.replace('&phone=', '&phone=%2B7+');

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: data,
                dataType: 'json',
                success: function(code) {
                    message.show();
                    form[0].reset();
                    $('.ap-reservation__text-field.js-ap-phone').val('')
                    submitButton.removeAttr('disabled');
                },
                error: function( jqXHR, textStatus ) {
                    console.log( "Request failed: " + textStatus );
                    submitButton.removeAttr('disabled');

                    alert('Возникла ошибка. Текст ошибки: ' + "\n" + jqXHR.responseText);
                }
            });
        }
    };
}());

tm.AvailablePopupFilter = library(function() {
    return {
        init: function () {
            this.elements = {
                filters: $('.js-ap-filter-form')
            };

            if (!this.elements.filters) return;

            this.queryData = [];
            this.queryLocation = [];
            this.lastRequestedDate = 0;

            this._bind();
        },
        _bind: function () {
            var obj = this;

            this.elements.filters.find('.available-sizes-items__list li').each(function() {
                var $li = $(this);
                var cat = $li.parent().data('id');

                obj._bindLinks($li, cat);
            });


            this.elements.filters.find('.filter-location select').each(function() {
                var select = $(this);
                var cat = $(this).attr('id');

                obj._bindSelect(select, cat);
            });

            $('.available-sizes__show_all').on('click', function (event) {
                var sizesLinks = $('.available-sizes-items__list a');
                sizesLinks.each(function () {
                    var $this = $(this);
                    $this.removeClass('ap-filter_link--active');
                });

                obj.queryData = [];
                sizesLinks.eq(0).addClass('ap-filter_link--active').click();
            });
        },
        query: function() {
            var obj = this;
            var sent = (new Date()).getTime();
            var data = this._param();
            //data += '&city=' + $('#available-city').val();
            //data += '&metro=' + $('#available-metro').val();
            data += '&availability_popup';

            $.ajax({
                // url: '/product/salons',
                method: 'POST',
                data: data,
                success: function(msg) {
                    if (obj.lastRequestedDate > sent) {
                        return;
                    }
                    obj.lastRequestedDate = sent;

                    $('.ap-goods-available').html(msg);
                    tm.AvailablePopupFilter.init();

                    var $availablePopupSlider = $('body').find('.ap-goods-available-salons');

                    if($availablePopupSlider.length && !$availablePopupSlider.hasClass('slick-slider') && window.innerWidth < 768)
                        initAvailablePopupSlider($availablePopupSlider);

                    // Re-set city value.
                    if ($('#available-city').val() && $('#available-city').val() !== '0') {
                        obj.queryLocation.push({c: 'available-city', p: $('#available-city').val()});
                    }


                    // Re-set metro value.
                    if ($('#available-metro').val() && $('#available-metro').val() !== '0') {
                        obj.queryLocation.push({c: 'available-metro', p: $('#available-metro').val()});
                    }


                    // Re-set params.
                    $('.available-sizes-items__list .ap-filter_link--active').each(function() {
                        var $this = $(this);

                        if ($this.parent().hasClass('all')) {
                            return;
                        }

                        obj.queryData.push({c: 2, p: $this.data('id')});
                    });

                }
            });
        },
        _bindLinks: function($li, cat) {
            var obj = this, all = $li.hasClass('all');
            $li.find('a:not(.dis):not(.wchbx), sale-badge').bind('click', function() {

                var $this = $(this);
                var cleanCat = function() {
                    var t = obj.queryData;

                    obj.queryData = [];
                    for (var i in t) {

                        if (t[i]['c'] != cat)
                            obj.queryData.push(t[i]);
                    }
                };

                if ($this.hasClass('ap-filter_link--active')) {
                    //removing class
                    if ($li.hasClass('all'))
                        return;
                    $this.removeClass('ap-filter_link--active');

                    //removing all entries for this category
                    cleanCat();

                    //adding entry for category
                    if ($li.siblings().find('.ap-filter_link--active').length)
                    {
                        $li.siblings().find('.ap-filter_link--active').each(function() {
                            obj.queryData.push({c: cat, p: $(this).data("id")});
                        });
                    } else {
                        $li.siblings('.all').find('a').addClass('ap-filter_link--active');
                    }
                } else {
                    if (all) {
                        $li.siblings().find('.ap-filter_link--active').removeClass('ap-filter_link--active');
                        cleanCat();
                    } else {
                        $li.siblings('.all').find('.ap-filter_link--active').removeClass('ap-filter_link--active');
                        obj.queryData.push({c: cat, p: $this.data('id')});
                    }
                    $this.addClass('ap-filter_link--active');
                }

                obj.query();
            });
        },
        _bindSelect: function(select, cat) {
            var obj = this;

            select.bind('change', function () {

                var cleanCat = function() {
                    var t = obj.queryLocation;

                    obj.queryLocation = [];

                    for (var i in t) {

                        if (t[i]['c'] != cat)
                            obj.queryLocation.push(t[i]);
                    }
                };

                if (cat === 'available-city') {
                    obj.queryLocation = [];
                }

                cleanCat();
                obj.queryLocation.push({c: cat, p: $(this).val()});
                obj.query();
            });
        },
        _param: function() {
            var ret = 'page=ap';
            var n = 0;

            for (var i in this.queryData) {
                i *= 1;
                n += 1;
                ret += ('&' + encodeURIComponent('s[' + n + '][c]') + '=' + encodeURIComponent(this.queryData[i]['c']) +
                '&' + encodeURIComponent('s[' + n + '][p]') + '=' + encodeURIComponent(this.queryData[i]['p']));
            }

            for (var j in this.queryLocation) {
                j *= 1;
                n += 1;
                ret += ('&' + encodeURIComponent('s[' + n + '][c]') + '=' + encodeURIComponent(this.queryLocation[j]['c']) +
                '&' + encodeURIComponent('s[' + n + '][p]') + '=' + encodeURIComponent(this.queryLocation[j]['p']));
            }

            return ret;
        }
    }
}());

tm.AvailablePopupMap = library(function() {
    return {
        init: function () {
            this.elements = {
                map: $('.js-ap-map')
            };

            if(!this.elements.map) return;

            this.bind();
        },
        bind: function () {
            var obj = this,
                link = $('.js-salons-buttons__map'),
                mapClose = $('.js-ap-map-close');

            link.on('click', function (event) {
                var self = $(this),
                    mObj = window.gMarkers,
                    salon = self.parents('.js-salon'),
                    mapWrap = salon.find('.js-ap-map'),
                    salonWrap = self.parents('.ap-goods-available-salons'),
                    mapTop,
                    cityId = self.attr('data-city'),
                    salonId = self.attr('data-id'),
                    id = 'map_'+cityId+'_'+salonId;

                event.preventDefault();

                obj._closeMap();

                var map = $('<div/>', {
                    id: id,
                    class: 'js-map-inner'
                }).appendTo(mapWrap);

                obj._addMap(mObj[cityId][salonId], id);

                if (salonWrap.offset()) {
                    mapTop = salon.offset().top - salonWrap.offset().top + salonWrap.scrollTop();

                    salonWrap.animate({
                        scrollTop: mapTop
                    }, 400);
                }
            });

            mapClose.on('click',  obj._closeMap);
        },
        _closeMap: function () {
            var wrap = $('.js-salon').parent(),
                map = wrap.find('.js-map-inner'),
                close = wrap.find('.js-ap-map-close'),
                link = wrap.find('.js-salons-buttons__map');

            map.remove();
            close.hide();
            link.show();

            return false;
        },
        _addMap: function (markerObj, id) {
            var marker = markerObj,
                myLatlng = new google.maps.LatLng(marker.lat, marker.long),
                myOptions,
                map,
                i;

            function showMap() {
                var map = $('#'+id),
                    wrap = map.parents('.ap-goods-available-salon__item'),
                    close = wrap.find('.js-ap-map-close'),
                    link = wrap.find('.js-salons-buttons__map');

                map.show(500);
                close.show();
                link.hide();
            }

            myOptions = {
                zoom: 14,
                scrollwheel: false,
                center: myLatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                zoomControl: false,
                streetViewControl: false
            };
            map = new google.maps.Map(document.getElementById(id), myOptions);

            this._addMarker(markerObj, map);
            showMap();
        },
        _addMarker: function (thisMarker, map) {
            var latlng = new google.maps.LatLng(thisMarker.lat,thisMarker.long),
                self = this;

            var markerImage = new google.maps.MarkerImage(
                '/img/marker.png',
                new google.maps.Size(43,47),
                new google.maps.Point(0,0),
                new google.maps.Point(0,47)
            );

            var marker = new google.maps.Marker({
                icon: markerImage,
                position: latlng,
                map: map
            });

            var contentString = '<div class="map-content">' +
                '<div class="map-salon">' + thisMarker.salon + '</div>' +
                '<div class="map-station">' +
                '<img src="' + thisMarker.icon + '"> ' +
                '<span>' + thisMarker.station + '</span>' +
                '</div>' +
                '<div class="map-info">' + thisMarker.info + '</div>' +
                '</div>';

            var infowindow = new google.maps.InfoWindow({
                content: contentString,
                pixelOffset: new google.maps.Size(-7, 0)
            });

            google.maps.event.addListener(marker, 'click', function() {

                /*if( self.prev_infowindow ) {
                 self.prev_infowindow.close();
                 }

                 self.prev_infowindow = infowindow;*/
                infowindow.open(map, marker);

            });

            google.maps.event.addListener(infowindow, 'domready', function() {
                var iwOuter = $('.gm-style-iw'),
                    iwBackground = iwOuter.prev(),
                    iwCloseBtn = iwOuter.next(),
                    iwparent = iwOuter.parent();

                iwCloseBtn.find('img').css({'display' : 'none'});
                iwCloseBtn.appendTo(iwOuter);

                iwCloseBtn.css({
                    opacity: '1',
                    right: '5px',
                    top: '5px',
                    width: '15px',
                    height: '15px',
                    background: 'url(/img/Close_icon.png) 0 0 no-repeat'
                });

                iwBackground.children(':nth-child(2)').css({'display' : 'none'});
                iwBackground.children(':nth-child(4)').css({'display' : 'none'});

                iwparent.css({'max-width': '10px', 'max-height': '10px'});
            });
        }
    }
}());

tm.PickupPopupMap = library(function() {
    return {
        init: function () {
            this.elements = {
                map: $('.js-pickup-map')
            };

            if(!this.elements.map) return;

            this.bind();
        },
        bind: function () {
            var obj = this,
                popup = $('#pickup-popup');

            popup.on('click', '.js-pickup-map-toggle', function (event) {
                var self = $(this),
                    salon = self.parents('.js-pickup-item'),
                    mapWrap = salon.find('.js-pickup-map'),
                    salonId = self.attr('data-id'),
                    dataMap = self.data('map'),
                    id = 'map_'+salonId;

                event.preventDefault();

                if($(this).closest('.js-pickup-item').hasClass('_map-sown')) return;

                obj._closeMap();

                var map = $('<div/>', {
                    id: id,
                    class: 'js-map-inner'
                }).appendTo(mapWrap);
                obj._addMap(dataMap, id);
            });

            popup.on('click', '.js-pickup-map-close', obj._closeMap);
        },
        _closeMap: function () {
            var popup = $('#pickup-popup');

            popup.find('.js-map-inner').remove();
            popup.find('.js-pickup-item').removeClass('_map-sown');

            return false;
        },
        _addMap: function (markerObj, id) {
            var marker = markerObj,
                myLatlng = new google.maps.LatLng(marker.lat, marker.long),
                myOptions,
                map,
                i;

            function showMap() {
                var map = $('#'+id);

                map.show(500);
            }

            myOptions = {
                zoom: 14,
                scrollwheel: false,
                center: myLatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                zoomControl: false,
                streetViewControl: false
            };
            map = new google.maps.Map(document.getElementById(id), myOptions);

            this._addMarker(markerObj, map);
            showMap();
        },
        _addMarker: function (thisMarker, map) {
            var latlng = new google.maps.LatLng(thisMarker.lat,thisMarker.long),
                self = this;

            var markerImage = new google.maps.MarkerImage(
                '/img/marker.png',
                new google.maps.Size(43,47),
                new google.maps.Point(0,0),
                new google.maps.Point(0,47)
            );

            var marker = new google.maps.Marker({
                icon: markerImage,
                position: latlng,
                map: map
            });

            var contentString = '<div class="map-content">' +
                '<div class="map-salon">' + thisMarker.salon + '</div>' +
                '<div class="map-station">' +
                '<img src="' + thisMarker.icon + '"> ' +
                '<span>' + thisMarker.station + '</span>' +
                '</div>' +
                '<div class="map-info">' + thisMarker.info + '</div>' +
                '</div>';

            var infowindow = new google.maps.InfoWindow({
                content: contentString,
                pixelOffset: new google.maps.Size(-7, 0)
            });

            google.maps.event.addListener(marker, 'click', function() {

                /*if( self.prev_infowindow ) {
                 self.prev_infowindow.close();
                 }

                 self.prev_infowindow = infowindow;*/
                infowindow.open(map, marker);

            });

            google.maps.event.addListener(infowindow, 'domready', function() {
                var iwOuter = $('.gm-style-iw'),
                    iwBackground = iwOuter.prev(),
                    iwCloseBtn = iwOuter.next(),
                    iwparent = iwOuter.parent();

                iwCloseBtn.find('img').css({'display' : 'none'});
                iwCloseBtn.appendTo(iwOuter);

                iwCloseBtn.css({
                    opacity: '1',
                    right: '5px',
                    top: '5px',
                    width: '15px',
                    height: '15px',
                    background: 'url(/img/Close_icon.png) 0 0 no-repeat'
                });

                iwBackground.children(':nth-child(2)').css({'display' : 'none'});
                iwBackground.children(':nth-child(4)').css({'display' : 'none'});

                iwparent.css({'max-width': '10px', 'max-height': '10px'});
            });
        }
    }
}());

//Spoilers
$(function() {
    var $spoiler = $('.js-spoiler-summary');
    if(!$spoiler.length) return;

    $spoiler.on('click', function() {
        var $that = $(this),
            $ctx = $that.closest('.js-spoiler-ctx'),
            $details = $ctx.find('.js-spoiler-details'),
            dataShow = $that.data('show'),
            dataHide = $that.data('hide');

        if($that.html() == dataShow) {
            $that.html(dataHide);
        } else {
            $that.html(dataShow);
        }

        $that.toggleClass('_active');
        $details.slideToggle(300);
    });
});

// Swipe for magnific popup
$(function() {
    var target = $('.js-collection');
    if(target.length === 0) return false;

    // console.log(target);

    $(document).on('click', function() {

        if($('body').hasClass('mfp-zoom-out-cur')) {
            // console.log('popup is active');

            $('body').swipe({
                swipeLeft: function(event, direction, distance, duration, fingerCount) {
                    $(".mfp-arrow-left").magnificPopup("prev");
                },
                swipeRight: function() {
                    $(".mfp-arrow-right").magnificPopup("next");
                },
                threshold: 50
            });
        } else {
            $("body").swipe("destroy");
        }

        console.log('check');
    });

});


// Spoilers for tags blocks

$(function() {
    // var toggle = $('.js-tag-spoiler');
    // if(toggle.length === 0) return false;

    // var data = toggle.data('spoiler'),
    //     textShow = toggle.data('text-show'),
    //     textHide = toggle.data('text-hide'),
    //     target = $('.js-tag-spoiler-details[data-spoiler="'+data+'"]');

    $(document).on('click', '.js-tag-spoiler', function() {
        var $that = $(this),
            data = $that.data('spoiler'),
            textShow = $that.data('text-show'),
            textHide = $that.data('text-hide'),
            target = $('.js-tag-spoiler-details[data-spoiler="'+data+'"]');

        if($that.hasClass('_active')) {
            $that.removeClass('_active');
            $that.html(textShow);
            target.removeClass('_active');
        } else {
            $that.addClass('_active');
            $that.html(textHide);
            target.addClass('_active');
        }
    });
});


// Фикc состояния :focus для iphone
$(function() {
    $('.catalog-link-look').attr("onclick","return true");
});


// Слайдер для Available Popup
function initAvailablePopupSlider(slider) {
    slider.slick({
        infinite: true,
        // adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<span class="promo-slider__prev">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
                            '<path d="M0.287,8.329 C2.606,10.461 4.925,12.594 7.245,14.725 C8.200,15.603 9.623,14.177 8.665,13.296 C6.600,11.399 4.536,9.502 2.472,7.604 C4.547,5.641 6.621,3.676 8.696,1.711 C9.641,0.817 8.217,-0.609 7.275,0.283 C4.945,2.489 2.616,4.694 0.287,6.900 C-0.099,7.266 -0.109,7.966 0.287,8.329 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
                        '</svg>' +
                    '</span>',
        nextArrow: '<span class="promo-slider__next">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
                            '<path d="M8.713,6.671 C6.394,4.539 4.075,2.406 1.755,0.275 C0.800,-0.603 -0.623,0.823 0.335,1.704 C2.400,3.601 4.464,5.498 6.528,7.396 C4.453,9.359 2.379,11.324 0.304,13.289 C-0.641,14.183 0.783,15.609 1.725,14.717 C4.055,12.511 6.384,10.306 8.713,8.100 C9.099,7.734 9.109,7.034 8.713,6.671 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
                        '</svg>' +
                    '</span>'
    });

    slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        console.log(event, slick, currentSlide, nextSlide);

        var $target = $(event.target),
            $map = $target.find('.js-map-inner');

        if($map.length) {
            $map.closest('.js-ap-map').find('.js-ap-map-close').click();
        }
    });
}

$(function() {

    // Эмулирет клик по размеру в попапе Available Popup
    $('.js-brands-item-slick').each(function() {

        $(this).slick({
            infinite: true,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    });

    $(window).scroll(function() {
        if (!this.scrolling) {
            this.scrolling = setTimeout(function () {
                clearTimeout(window.scrolling);
                window.scrolling = null;
                $(window).trigger('win:scroll', {scrollTop: $(window).scrollTop()});
            }, 200);
        }
    });

    $('.brands-item.__shifted').each(function() {
        var $that = $(this);

        $(window).on('win:scroll', function(e, data) {
            if(data.scrollTop > $that.offset().top - $(window).height()){
                $that.removeClass('__shifted');
            }
        });
    });

    $(window).trigger('win:scroll', {scrollTop: $(window).scrollTop()});
});

// Видеоблок
$(document).ready(function () {
    var $videoContainer = $('.js-video-block');
    if(!$videoContainer.length) return;

    $videoContainer.click(function(){
        var $this = $(this);
        var url = $this.data('url');
        var $preloader = $this.find('.video-preloader');

        $preloader.after('<iframe width="1200" height="670" src="'+url+'?wmode=transparent&autoplay=1" frameborder="0" allowfullscreen></iframe>');
        $preloader.remove();
    });
});

// попап пунктов доставки
$(function () {
    var popup = $('#pickup-popup'),
        searchInput = $('.js-pickup-search', popup),
        pickupForm = $('.js-pickup-form', popup),
        pickupButton = $('.js-bickup-button', popup),
        itemList = $('.js-pickup-list', popup),
        orderWrap = $('.js-order-step-shipping');

    // раскрытие карты
    popup.on('click', '.js-pickup-map-toggle', function () {
        $(this).closest('.js-pickup-item').toggleClass('_map-sown').siblings().removeClass('_map-sown');
    });

    // простой поиск пунктов доставки по контенту
    searchInput.on('keyup change', function (e) {
        var input = $(this),
            items = $('.js-pickup-item', popup);

        if ($(this).val().length >= 3) {
            items.addClass('_hidden').filter(function () {
                return $(this).find('.js-search-data').text().toLowerCase().indexOf(input.val().toLowerCase()) >= 0;
            }).removeClass('_hidden');
        } else {
            items.removeClass('_hidden');
        }
    });

    // отключаем чекбоксы пункта выдачи если выбрана доставка курьером
    $(document).on('click', '.js-order-step-shipping .ordering-delivery-courier.js-delivery-input', function () {
        $('.js-order-step-shipping .js-delivery-pickup-input').prop('disabled', true);
    });

    // синхронизуем радио службы доставки и адреса выдачи
    $(document).on('click', '.js-order-step-shipping .ordering-delivery-pickup.js-delivery-input', function () {
        $(this).parent().find('.js-delivery-pickup-input').prop('disabled', false).prop('checked', true);
        $('#pickupPlace-error').remove();
    });

    // открываем попап с адресами
    $(document).on('click', '.js-order-step-shipping .js-delivery-pickup-change', function () {
        $(this).parent().find('.js-delivery-pickup-input').prop('disabled', false).prop('checked', true);
        $('#pickupPlace-error').remove();
        openModWin({'element': 'pickup-popup'});
        $(document).trigger('pickup:popup', this);
        return false;
    });

    // получение и настройка данных при открытии попапа пунктов доставки
    $(document).on('pickup:popup', function (e, context) {
        var input = $(context).closest('.ordering-input-wr-delivery').find('.js-delivery-input'),
            url = $(context).data('url');

        if(!input.is(':checked')) {
            input.prop('checked', true).change();
        }
        searchInput.val('').change();
        centralAlign(popup);
        pickupForm.data('context', $(context));

        var data = {
            id: input.val()
        };

        if (!$(context).data('list')) {
            pickupButton.attr('disabled', true);
            itemList.addClass('_loading').empty();
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                dataType: 'html',
                success: function (data) {
                    $(context).data('list', data);
                    itemList.html(data);
                    centralAlign(popup);
                    searchInput.change();
                    bindPickup(context);
                },
                error: function (jqXHR, textStatus) {
                    console.log("Request failed: " + textStatus);
                    alert('Возникла ошибка. Текст ошибки: ' + "\n" + jqXHR.responseText);
                },
                complete: function () {
                    itemList.removeClass('_loading');
                }
            });

        } else {
            itemList.empty().html($(context).data('list'));
            searchInput.change();
            bindPickup(context);
            if ($(context).data('listCurrent')){
                itemList.find('.js-pickup-input').filter('[value=\'' + $(context).data('listCurrent').value + '\']').prop('checked', true);
            } else {
                pickupButton.attr('disabled', true);
            }
        }
    });

    pickupButton.on('click',  function () {
        var current = pickupForm.find('.js-pickup-input').filter(':checked');

        pickupForm.data('context').siblings('.js-delivery-pickup-input').val(current.val()).prop('checked', true).change();
        $('#pickupPlace-error').remove();
        $(this).closest('form').valid();
        pickupForm.data('context').parent().find('b').remove();
        $('<b>' + current.next().text() + '</b>').insertBefore(pickupForm.data('context'));
        closeModWin(popup.attr('id'));

        // вызов функций hideConfirmOrderButton и loadPayment описанных в файле /shop/protected/views/ordering/ordering/address.php
        $(document).trigger('pickup:button');
    });

    function bindPickup(context) {
        itemList.find('.js-pickup-input').on('change', function () {
            $(context).data('listCurrent', this);
            pickupButton.removeAttr('disabled');
        });
    }
});
